import { UPDATE_FILTERS, RESET_FILTERS } from './constants'
import type { FiltersState } from './state'

export interface UpdateFiltersAction {
  type: typeof UPDATE_FILTERS
  payload: FiltersState
}

export interface ResetFiltersAction {
  type: typeof RESET_FILTERS
}

export type FiltersActions = UpdateFiltersAction | ResetFiltersAction

export const updateFiltersAction = (payload: UpdateFiltersAction['payload']) => ({
  type: UPDATE_FILTERS,
  payload,
})

export const resetFiltersAction = () => ({
  type: RESET_FILTERS,
})
